<template>
        <div
          v-if="showGoalsModal"
          class="modal-overlay"
          @click="$store.commit('setShowGoalsModal', false)"
        >
          <div class="modal-content" @click.stop>
            <div v-if="!showSpinner">
              <div class="modal-header">
                  <h2>{{ !localEditingGoal || !localEditingGoal.id ? "Create Goal" : "Edit"}}</h2>
                  <span class="modal-header-description">Fill in the details to add your goal.</span>
              </div>
              <div class="input-div">
                  <span class="d-flex label w-100">Goal</span>
                  <div class="textarea-background">
                    <textarea
                      name="goal-name"
                      placeholder="Gotta type something in here bub..."
                      v-model="localEditingGoal.goal"
                      rows="3"
                    ></textarea>
                </div>
              </div>
              <div class="input-div">
                  <span class="d-flex label w-100">Due Date</span>
                  <input type="datetime-local" v-model="localEditingGoal.due_date"/>
                </div>
                <div v-if="!localEditingGoal.id" class="input-div d-flex flex-direction-column gap-5">
                  <div class="d-flex align-items-center gap-5">
                    <input id="ai_generate" type="radio" name="ai_generate_tasks" class="styled-radio" v-model="localEditingGoal.ai_generate_tasks" value="true"/>
                    <label for="ai_generate" class="cursor-pointer">
                      Let AI generate Tasks
                    </label>
                  </div>
                  <div class="d-flex align-items-center gap-5">
                    <input id="manual_add" type="radio" name="ai_generate_tasks" class="styled-radio" v-model="localEditingGoal.ai_generate_tasks" value="false"/>
                    <label for="manual_add" class="cursor-pointer">Create Task Manually</label>
                  </div>
                </div>
                <div v-if="localEditingGoal.id" class="input-div d-flex flex-direction-column gap-5">
                  <div class="d-flex align-items-center gap-5">
                    <input id="regen_subtasks" type="radio" name="handle_subtasks" class="styled-radio" v-model="localEditingGoal.handle_subtasks" value="regen"/>
                    <label for="regen_subtasks" class="cursor-pointer" @click.stop.prevent="labelClick('regen')">Regenerate Sub Tasks with AI</label>
                  </div>
                  <div class="d-flex align-items-center gap-5">
                    <input id="keep_subtasks" type="radio" name="handle_subtasks" class="styled-radio" v-model="localEditingGoal.handle_subtasks" value="keep"/>
                    <label for="keep_subtasks" class="cursor-pointer" @click.stop.prevent="labelClick('keep')">Keep Tasks as they are</label>
                  </div>
                  <div class="d-flex align-items-center gap-5">
                    <input id="delete_subtasks" type="radio" name="handle_subtasks" class="styled-radio" v-model="localEditingGoal.handle_subtasks" value="delete"/>
                    <label for="delete_subtasks" class="cursor-pointer" @click.stop.prevent="labelClick('delete')">Delete Sub Tasks</label>
                  </div>
                </div>
                <div class="modal-actions">
                  <button class="secondary" @click="$store.commit('setShowGoalsModal', false)">Cancel</button>
                  <button class="primary" @click.stop="doEditGoal()">{{ !localEditingGoal.id ? "Add" : "Save"}}</button>
                </div>
              </div>
              <div v-if="showSpinner">
                <LoadingSpinner  />
              </div>
            </div>
          
        </div>
     
</template>
  
<script>
import { mapGetters } from 'vuex';
import LoadingSpinner from './LoadingSpinner.vue';
export default {
  name: "EditGoalModal", 
 
  components: {
    LoadingSpinner,
  },
  computed: {
    ...mapGetters(['selectedProject','showGoalsModal','activeGoal']), // Access Vuex state via getter
  },
  data() {
    return {
        localEditingGoal: {
          ai_generate_tasks: true,
          handle_subtasks: '',
          goal: '', // Initialize this
          due_date: null, // Initialize this too
        },
        showSpinner: false,
    };
  },
mounted() {
  if (this.activeGoal) {
    for (const key in this.activeGoal) {
      this.localEditingGoal[key] = this.activeGoal[key];
    }

    // Ensure default value for handle_subtasks
    if (!this.localEditingGoal.handle_subtasks && this.localEditingGoal.id) {
      this.localEditingGoal.handle_subtasks = 'regen';
      delete this.localEditingGoal.ai_generate_tasks;
    }
  }
},
  methods: {
    labelClick(label){
      this.localEditingGoal.handle_subtasks = label; // Update the value directly
      console.log(this.localEditingGoal.handle_subtasks);
    },
    async doEditGoal() {
      try {
        this.showSpinner = true;
        this.localEditingGoal.project_id = this.selectedProject.id;
        if(this.localEditingGoal.id){
          delete this.localEditingGoal.ai_generate_tasks;
        }
        await this.$store.dispatch('editGoal', this.localEditingGoal);
        this.showSpinner = false;
        //const result = await goalsService.createGoal(goal);
        //this.$store.dispatch('getGoals', this.selectedProject.id);
        //this.newGoal = '';
        //this.tasks = result.tasks; // Assuming backend returns tasks
      } catch (error) {
        console.error('Error fetching tasks:', error);
      }
    },
  },
};
</script>
  
  
<style scoped>
.input-div {
  margin-bottom: 20px;
}
.label {
  margin-bottom: 5px;
}
.textarea-background {
  background-color: var(--Theme-Color-Secondary-Black);
  border: 1px solid var(--Border-Color-Primary);
  border-radius: 15px;
  display: flex;
  padding: 15px;
}
/* Goal Name Input */
.goal-name-input {
  color: var(--dark-colo-a0);
  background-color: transparent;
  border: 1px solid #5a5a5a; /* or use var(--Border-Color-Primary) if you prefer */
  border-radius: 5px;
  padding: 10px;
  font-size: 1rem;
  margin: 10px 0;
}
h2 {
  margin-bottom: 5px;
}
/* Modal Header */
.modal-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.modal-header-description {
  font-family: var(--body-font);
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  color: var(--dark-colo-a0);
}
/* Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%; 
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex; 
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
/* Modal Content */
.modal-content {
  background: var(--Theme-Color-Secondary-Black);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  max-width: 600px;
  width: 90%;
  display: flex;
  flex-direction: column;
}
.modal-content h2 {
  margin-top: 0;
  font-size: 20px;
  color: var(--white-color);
}
/* Modal Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.modal-actions .secondary,
.modal-actions .primary {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

</style>